import { Subject } from "rxjs";
import { IEventSubscription } from "../../domain/events/IEventHandler";
import { IEventProvider } from "../../domain/events/IEventProvider";

export class EventPlug implements IEventProvider {
    private _messages$: Map<string, Subject<any>>;

    constructor() {
        this._messages$ = new Map<string, Subject<any>>();
    }

    public emit(messageType: string, data: any = {}) {
        const subject = this._getSubjectForEvent(messageType);
        setTimeout(() => subject.next(data), 0);
    }


    public subscribe<T>(eventName: string, fn: (data: T) => void): IEventSubscription {
        const subscription = this._getSubjectForEvent(eventName).asObservable().subscribe(fn);
        return subscription;
    }

    private _getSubject() {
        return new Subject();
    }

    private _getSubjectForEvent(eventName: string): Subject<any> {
        if (!this._messages$.has(eventName)) {
            this._messages$.set(eventName, this._getSubject());
        }
        const subject = this._messages$.get(eventName);
        if (subject === undefined) {
            throw new Error(`${eventName} not available`);
        }
        return subject;
    }
}
